<template>
  <div class="identity" id="identity">
    <section>
      <sub-title :title="title" :content="content" :content2="content2"> </sub-title>
    </section>
    <section class="word-mark full-page-scroll identity-section">
      <h2 class="identity-heading scroll-fade-in-f">
        Word Mark<br />
        워드마크
      </h2>
      <p class="scroll-fade-in-f scroll-delay-1">
        다비치는 세상을 맑고 밝게 비춘다는 순 우리말로 소외된 어려운 이웃까지 맑고 밝게 다 비춘다는 의미입니다.<br />
        워드마크는 다비치 브랜드의 아이덴티티와 핵심가치를 함축적으로 담고 있습니다.<br />
        다비치와 고객이 신뢰로 함께 만들어온 전통과 새롭게 펼쳐질 미래를 밝게 비추어 가는 아름다운 빛을 시각적으로
        표현하였습니다.
      </p>
      <div class="wordmark-logo">
        <div class="scroll-fade-in-f">
          <div class="img">
            <img src="https://img.davich.com/mobile/image/sub/about/logo-wordmark.png" alt="davich wordmark english" />
          </div>
          <span><div>워드마크 (영문)</div></span>
        </div>
        <div class="scroll-fade-in-f scroll-delay-1">
          <div class="img2">
            <img src="https://img.davich.com/mobile/image/sub/about/logo-wordmark-ko-01.png" alt="davich wordmark" />
          </div>
          <span><div>워드마크 (국문)</div></span>
        </div>
      </div>
    </section>
    <!-- /.wordmark -->
    <section class="slogan full-page-scroll identity-section ly-cont-m">
      <h2 class="identity-heading scroll-fade-in-f">
        Brand Slogan<br />
        슬로건
      </h2>
      <p class="scroll-fade-in-f scroll-delay-1">
        고객의 가치있는 미래를 열어가는 다비치의 브랜드 미션을 기준으로 신뢰, 조율, 공감의 브랜드 핵심가치가 새로운
        다비치 브랜드를 구체화 할 수 있도록 구성되어 있으며, Light Up Your Life 이라는 슬로건을 중심으로 다비치가
        나아가야 할 방향을 설정하였습니다.<br />
      </p>
      <div class="slogan-logo scroll-fade-in-f">
        <img src="https://img.davich.com/mobile/image/sub/about/slogan.png" alt="davich slogan" />
      </div>
    </section>
    <!-- /.slogan -->
    <section class="signature identity-section ly-cont-m">
      <h2 class="hidden">시그니처</h2>
      <article class="symbol full-page-scroll ly-cont-m">
        <h3 class="identity-heading scroll-fade-in-f">
          Signature<br />
          시그니처
        </h3>
        <div class="symbol-cont">
          <div class="symbol-motif symbol-item scroll-fade-in-f">
            <h4>Symbol motif</h4>
            <p>
              빛이 어둠에 은은하게 비추어 들어와 표면에 맺혀 부드럽고 따스하게 스며들어가는 형상을 바탕으로 신뢰하고
              공감하고 조율하는 다비치다움을 모던하고 심플하게 해석하여 시각적으로 표현했습니다.
            </p>
            <div class="img">
              <img
                src="https://img.davich.com/mobile/image/sub/about/symbol-motif.png"
                alt="davich symbol motif picture"
              />
            </div>
          </div>
          <div class="symbol-mark symbol-item scroll-fade-in-f scroll-delay-1">
            <h4>Symbol Mark</h4>
            <p>
              다비치의 심볼의 12가지 빛의 흐름은 고객과 사회를 향한 봉사정신과 고객을 위해 묵묵히 노력하는 발걸음,
              그리고 고객에게 감동을 전달하고자 하는 다비치의 사명감을 나타냅니다. 다비치의 새로운 심볼은 “어둠을 뚫고
              나가는 빛의 형상이 새롭고 조화로운 질서로 맺혀 하나가 되어가는 과정을 의미합니다.”
            </p>
            <div class="img2">
              <img
                src="https://img.davich.com/mobile/image/sub/about/symbol-mark-01.png"
                alt="davich symbol motif picture"
              />
            </div>
          </div>
        </div>
      </article>
    </section>
    <!-- /.signature 01 -->
    <section class="signature identity-section ly-cont-m">
      <article class="signature-combine full-page-scroll ly-cont-m">
        <div class="combine-ttl">
          <h3 class="identity-heading scroll-fade-in-f">
            Signature<br />
            시그니처
          </h3>
          <p class="signiturep scroll-fade-in-f scroll-delay-1">
            다비치의 심볼마크와 워드마크 그리고 슬로건의 조합은 각 형태에 따라 비례를 조정한 것이므로 사용의 오류를
            방지하기 위해 모든 원고의 사용은 매뉴얼 데이터에 의한 확대, 축소, 복사가 되어야 합니다.
          </p>
        </div>
        <div class="combine-content">
          <p class="pcenter">시그니처 상하 조합</p>
          <div class="combine-updown scroll-fade-in-f scroll-delay-2">
            <img src="@/assets/image/using/sub/about/logo-signature.png" alt="davich signature logo" />
          </div>
          <div class="combine-leftright scroll-fade-in-f scroll-delay-3">
            <div class="combine-item">
              <p>시그니처 안경 좌우조합(국문)</p>
              <div class="img">
                <img src="@/assets/image/using/sub/about/logo-gl.png" alt="davich glasses signature logo" />
              </div>
            </div>
            <div class="combine-item">
              <p>시그니처 보청기 좌우조합(국문)</p>
              <div class="img">
                <img src="@/assets/image/using/sub/about/logo-hearing.png" alt="davich hearing signature logo" />
              </div>
            </div>
            <div class="combine-item">
              <p>시그니처 렌즈 좌우조합(국문)</p>
              <div class="img">
                <img src="@/assets/image/using/sub/about/logo-lens.png" alt="davich lens signature logo" />
              </div>
            </div>
            <div class="combine-item">
              <p>시그니처 안경 좌우조합(영문)</p>
              <div class="img">
                <img src="@/assets/image/using/sub/about/logo-gl-en.png" alt="davich glasses signature logo" />
              </div>
            </div>

            <div class="combine-item">
              <p>시그니처 보청기 좌우조합(영문)</p>
              <div class="img">
                <img src="@/assets/image/using/sub/about/logo-hearing-en.png" alt="davich hearing signature logo" />
              </div>
            </div>
            <div class="combine-item">
              <p>시그니처 렌즈 좌우조합(영문)</p>
              <div class="img">
                <img src="@/assets/image/using/sub/about/logo-lens-en.png" alt="davich lens signature logo" />
              </div>
            </div>
            <!-- <div class="combine-item">
              <p>시그니처 마켓 좌우조합(국문)</p>
              <div class="img">
                <img
                  src="https://img.davich.com/mobile/image/sub/about/logo-market.png"
                  alt="davich glasses signature logo"
                />
              </div>
            </div>
            <div class="combine-item3">
              <p>시그니처 마켓 좌우조합(영문)</p>
              <div class="img">
                <img
                  src="https://img.davich.com/mobile/image/sub/about/logo-market-en.png"
                  alt="davich glasses signature logo"
                />
              </div>
            </div> -->
          </div>
        </div>
      </article>
    </section>
    <!-- /.signature 02 -->
  </div>
</template>

<script>
import SubTitle from "../../../components/mobile/MSubTitle1.vue";

export default {
  components: {
    SubTitle,
  },
  data() {
    return {
      title: "비주얼 아이덴티티",
      content: "전문성과 신뢰를 바탕으로 한 ",
      content2: "최고의 안경전문기업, 다비치입니다.",
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/helpers/variables";
@import "~@/assets/scss/helpers/mixins";
@import "~@/assets/scss/base/typhography";

.sub-title {
  background-image: url("https://img.davich.com/mobile/image/sub/subtitle/sub-about-bg-02.png");
}

//word-mark
.word-mark {
  .identity-heading {
    font-family: $ko-font;
    font-size: 30px;
    text-align: center;
    font-weight: 700;
    margin-top: 60px;
    line-height: 40px;
  }
  p {
    width: 85vw;
    margin: auto;
    text-align: left;
    line-height: 25px;
    margin-top: 40px;
  }
}
.wordmark-logo {
  .img img {
    width: 220px;
    display: block;
    margin: auto;
    margin-top: 50px;
    margin-bottom: 10px;
  }
  .img2 img {
    width: 154px;
    display: block;
    margin: auto;
    margin-top: 50px;
    margin-bottom: 10px;
  }
  span {
    width: 85vw;
    text-align: center;
    line-height: 30px;
  }
}
//slogan
.slogan {
  width: 85vw;
  .slogan-logo img {
    width: 325px;
    display: block;
    margin: 70px auto;
  }
  .identity-heading {
    font-family: $ko-font;
    font-size: 30px;
    text-align: center;
    font-weight: 700;
    margin-top: 190px;
    line-height: 40px;
  }
  p {
    width: 85vw;
    margin: auto;
    text-align: left;
    line-height: 25px;
    margin-top: 40px;
  }
}
//signature
.signature {
  width: 85vw;
  .img img {
    width: 85vw;
    margin: 30px auto 20px;
  }
  .identity-heading {
    font-family: $en-font;
    font-size: 30px;
    text-align: center;
    font-weight: 700;
    line-height: 40px;
    margin-top: 190px;
  }
  h4 {
    margin-top: 50px;
    font-size: 22px;
    font-weight: 700;
  }
  p {
    width: 85vw;
    margin-left: 0px;
    text-align: left;

    line-height: 25px;
    margin-top: 20px;
  }
  .signiturep {
    margin-top: 40px;
  }
  .img2 img {
    width: 214px;
    display: block;
    margin: 40px auto;
  }
}
.combine-content {
  width: 85vw;
  margin-bottom: 160px;
  .combine-updown img {
    width: 150px;
    display: block;
    margin: 30px auto 90px;
  }
  .pcenter {
    margin-top: 70px;
    text-align: center;
    margin-bottom: 10px;
  }
  p {
    margin-top: 35px;
    text-align: left;
  }
  .combine-item img {
    height: 40px;
    width: auto;
    margin-top: 13px;
  }
}
</style>
